'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDoc$002dSigner from "./presto.types$-Doc-Signer.js";
import * as $j_presto$002etypes$0024$002dDoc$002dSigner$0024$0024anon$0024131 from "./presto.types$-Doc-Signer$$anon$131.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DocSigner$$anon$134(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DocSigner$$anon$134 as $c_Lpresto_types$DocSigner$$anon$134 };
$p = $c_Lpresto_types$DocSigner$$anon$134.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DocSigner$$anon$134;
/** @constructor */
function $h_Lpresto_types$DocSigner$$anon$134() {
}
export { $h_Lpresto_types$DocSigner$$anon$134 as $h_Lpresto_types$DocSigner$$anon$134 };
$h_Lpresto_types$DocSigner$$anon$134.prototype = $p;
$p.bN = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$DocSigner$().cwB(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cAU = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAU(t);
});
var $d_Lpresto_types$DocSigner$$anon$134 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DocSigner$$anon$134, "presto.types$DocSigner$$anon$134", ({
  ZL: 1,
  K: 1
}));
export { $d_Lpresto_types$DocSigner$$anon$134 as $d_Lpresto_types$DocSigner$$anon$134 };
function $s_Lpresto_types$DocSigner$__bry__Lpresto_types$DocSigner() {
  $m_Lpresto_types$DocSigner$();
  return $t_Lpresto_types$DocSigner$__bry;
}
export { $s_Lpresto_types$DocSigner$__bry__Lpresto_types$DocSigner as $s_Lpresto_types$DocSigner$__bry__Lpresto_types$DocSigner };
function $s_Lpresto_types$DocSigner$__cms__Lpresto_types$DocSigner() {
  $m_Lpresto_types$DocSigner$();
  return $t_Lpresto_types$DocSigner$__cms;
}
export { $s_Lpresto_types$DocSigner$__cms__Lpresto_types$DocSigner as $s_Lpresto_types$DocSigner$__cms__Lpresto_types$DocSigner };
function $s_Lpresto_types$DocSigner$__pje__Lpresto_types$DocSigner() {
  $m_Lpresto_types$DocSigner$();
  return $t_Lpresto_types$DocSigner$__pje;
}
export { $s_Lpresto_types$DocSigner$__pje__Lpresto_types$DocSigner as $s_Lpresto_types$DocSigner$__pje__Lpresto_types$DocSigner };
function $s_Lpresto_types$DocSigner$__pkie__Lpresto_types$DocSigner() {
  $m_Lpresto_types$DocSigner$();
  return $t_Lpresto_types$DocSigner$__pkie;
}
export { $s_Lpresto_types$DocSigner$__pkie__Lpresto_types$DocSigner as $s_Lpresto_types$DocSigner$__pkie__Lpresto_types$DocSigner };
function $s_Lpresto_types$DocSigner$__serpro__Lpresto_types$DocSigner() {
  $m_Lpresto_types$DocSigner$();
  return $t_Lpresto_types$DocSigner$__serpro;
}
export { $s_Lpresto_types$DocSigner$__serpro__Lpresto_types$DocSigner as $s_Lpresto_types$DocSigner$__serpro__Lpresto_types$DocSigner };
function $s_Lpresto_types$DocSigner$__shodo__Lpresto_types$DocSigner() {
  $m_Lpresto_types$DocSigner$();
  return $t_Lpresto_types$DocSigner$__shodo;
}
export { $s_Lpresto_types$DocSigner$__shodo__Lpresto_types$DocSigner as $s_Lpresto_types$DocSigner$__shodo__Lpresto_types$DocSigner };
/** @constructor */
function $c_Lpresto_types$DocSigner$() {
  this.c60 = null;
  this.c63 = null;
  this.c64 = false;
  this.c61 = null;
  this.c62 = false;
  this.c65 = null;
  this.c66 = false;
  this.c67 = null;
  this.c68 = false;
  $n_Lpresto_types$DocSigner$ = this;
  $t_Lpresto_types$DocSigner$__bry = new $j_presto$002etypes$0024$002dDoc$002dSigner$0024$0024anon$0024131.$c_Lpresto_types$DocSigner$$anon$131(0, "bry", this);
  $t_Lpresto_types$DocSigner$__cms = new $j_presto$002etypes$0024$002dDoc$002dSigner$0024$0024anon$0024131.$c_Lpresto_types$DocSigner$$anon$131(1, "cms", this);
  $t_Lpresto_types$DocSigner$__pje = new $j_presto$002etypes$0024$002dDoc$002dSigner$0024$0024anon$0024131.$c_Lpresto_types$DocSigner$$anon$131(2, "pje", this);
  $t_Lpresto_types$DocSigner$__pkie = new $j_presto$002etypes$0024$002dDoc$002dSigner$0024$0024anon$0024131.$c_Lpresto_types$DocSigner$$anon$131(3, "pkie", this);
  $t_Lpresto_types$DocSigner$__serpro = new $j_presto$002etypes$0024$002dDoc$002dSigner$0024$0024anon$0024131.$c_Lpresto_types$DocSigner$$anon$131(4, "serpro", this);
  $t_Lpresto_types$DocSigner$__shodo = new $j_presto$002etypes$0024$002dDoc$002dSigner$0024$0024anon$0024131.$c_Lpresto_types$DocSigner$$anon$131(5, "shodo", this);
  this.c60 = new ($j_presto$002etypes$0024$002dDoc$002dSigner.$d_Lpresto_types$DocSigner.r().C)([$s_Lpresto_types$DocSigner$__bry__Lpresto_types$DocSigner(), $s_Lpresto_types$DocSigner$__cms__Lpresto_types$DocSigner(), $s_Lpresto_types$DocSigner$__pje__Lpresto_types$DocSigner(), $s_Lpresto_types$DocSigner$__pkie__Lpresto_types$DocSigner(), $s_Lpresto_types$DocSigner$__serpro__Lpresto_types$DocSigner(), $s_Lpresto_types$DocSigner$__shodo__Lpresto_types$DocSigner()]);
}
export { $c_Lpresto_types$DocSigner$ as $c_Lpresto_types$DocSigner$ };
$p = $c_Lpresto_types$DocSigner$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DocSigner$;
/** @constructor */
function $h_Lpresto_types$DocSigner$() {
}
export { $h_Lpresto_types$DocSigner$ as $h_Lpresto_types$DocSigner$ };
$h_Lpresto_types$DocSigner$.prototype = $p;
$p.cRg = (function() {
  return this.c60.as();
});
$p.cwB = (function(\u03b4name) {
  switch (\u03b4name) {
    case "bry": {
      return $s_Lpresto_types$DocSigner$__bry__Lpresto_types$DocSigner();
      break;
    }
    case "cms": {
      return $s_Lpresto_types$DocSigner$__cms__Lpresto_types$DocSigner();
      break;
    }
    case "pje": {
      return $s_Lpresto_types$DocSigner$__pje__Lpresto_types$DocSigner();
      break;
    }
    case "pkie": {
      return $s_Lpresto_types$DocSigner$__pkie__Lpresto_types$DocSigner();
      break;
    }
    case "serpro": {
      return $s_Lpresto_types$DocSigner$__serpro__Lpresto_types$DocSigner();
      break;
    }
    case "shodo": {
      return $s_Lpresto_types$DocSigner$__shodo__Lpresto_types$DocSigner();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.cI8 = (function() {
  if ((!this.c64)) {
    this.c63 = new $c_Lpresto_types$DocSigner$$anon$132(this);
    this.c64 = true;
  }
  return this.c63;
});
$p.iI = (function() {
  if ((!this.c62)) {
    this.c61 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$DocSigner$().cwB(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa);
    this.c62 = true;
  }
  return this.c61;
});
$p.cIB = (function() {
  if ((!this.c66)) {
    this.c65 = new $c_Lpresto_types$DocSigner$$anon$133(this);
    this.c66 = true;
  }
  return this.c65;
});
$p.css = (function() {
  if ((!this.c68)) {
    this.c67 = new $c_Lpresto_types$DocSigner$$anon$134(this);
    this.c68 = true;
  }
  return this.c67;
});
var $d_Lpresto_types$DocSigner$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DocSigner$, "presto.types$DocSigner$", ({
  ZH: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$DocSigner$ as $d_Lpresto_types$DocSigner$ };
var $n_Lpresto_types$DocSigner$;
function $m_Lpresto_types$DocSigner$() {
  if ((!$n_Lpresto_types$DocSigner$)) {
    $n_Lpresto_types$DocSigner$ = new $c_Lpresto_types$DocSigner$();
  }
  return $n_Lpresto_types$DocSigner$;
}
export { $m_Lpresto_types$DocSigner$ as $m_Lpresto_types$DocSigner$ };
/** @constructor */
function $c_Lpresto_types$DocSigner$$anon$132(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DocSigner$$anon$132 as $c_Lpresto_types$DocSigner$$anon$132 };
$p = $c_Lpresto_types$DocSigner$$anon$132.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DocSigner$$anon$132;
/** @constructor */
function $h_Lpresto_types$DocSigner$$anon$132() {
}
export { $h_Lpresto_types$DocSigner$$anon$132 as $h_Lpresto_types$DocSigner$$anon$132 };
$h_Lpresto_types$DocSigner$$anon$132.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$DocSigner$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$DocSigner$$anon$132 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DocSigner$$anon$132, "presto.types$DocSigner$$anon$132", ({
  ZJ: 1,
  a: 1,
  k: 1
}));
export { $d_Lpresto_types$DocSigner$$anon$132 as $d_Lpresto_types$DocSigner$$anon$132 };
/** @constructor */
function $c_Lpresto_types$DocSigner$$anon$133(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DocSigner$$anon$133 as $c_Lpresto_types$DocSigner$$anon$133 };
$p = $c_Lpresto_types$DocSigner$$anon$133.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DocSigner$$anon$133;
/** @constructor */
function $h_Lpresto_types$DocSigner$$anon$133() {
}
export { $h_Lpresto_types$DocSigner$$anon$133 as $h_Lpresto_types$DocSigner$$anon$133 };
$h_Lpresto_types$DocSigner$$anon$133.prototype = $p;
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cy = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cq = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cI = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cz = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$DocSigner$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x.l(), y.l());
});
var $d_Lpresto_types$DocSigner$$anon$133 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DocSigner$$anon$133, "presto.types$DocSigner$$anon$133", ({
  ZK: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$DocSigner$$anon$133 as $d_Lpresto_types$DocSigner$$anon$133 };
var $t_Lpresto_types$DocSigner$__bry = null;
function $u_Lpresto_types$DocSigner$__bry(x) {
  $t_Lpresto_types$DocSigner$__bry = x;
}
export { $t_Lpresto_types$DocSigner$__bry as $t_Lpresto_types$DocSigner$__bry, $u_Lpresto_types$DocSigner$__bry as $u_Lpresto_types$DocSigner$__bry };
var $t_Lpresto_types$DocSigner$__cms = null;
function $u_Lpresto_types$DocSigner$__cms(x) {
  $t_Lpresto_types$DocSigner$__cms = x;
}
export { $t_Lpresto_types$DocSigner$__cms as $t_Lpresto_types$DocSigner$__cms, $u_Lpresto_types$DocSigner$__cms as $u_Lpresto_types$DocSigner$__cms };
var $t_Lpresto_types$DocSigner$__pje = null;
function $u_Lpresto_types$DocSigner$__pje(x) {
  $t_Lpresto_types$DocSigner$__pje = x;
}
export { $t_Lpresto_types$DocSigner$__pje as $t_Lpresto_types$DocSigner$__pje, $u_Lpresto_types$DocSigner$__pje as $u_Lpresto_types$DocSigner$__pje };
var $t_Lpresto_types$DocSigner$__pkie = null;
function $u_Lpresto_types$DocSigner$__pkie(x) {
  $t_Lpresto_types$DocSigner$__pkie = x;
}
export { $t_Lpresto_types$DocSigner$__pkie as $t_Lpresto_types$DocSigner$__pkie, $u_Lpresto_types$DocSigner$__pkie as $u_Lpresto_types$DocSigner$__pkie };
var $t_Lpresto_types$DocSigner$__serpro = null;
function $u_Lpresto_types$DocSigner$__serpro(x) {
  $t_Lpresto_types$DocSigner$__serpro = x;
}
export { $t_Lpresto_types$DocSigner$__serpro as $t_Lpresto_types$DocSigner$__serpro, $u_Lpresto_types$DocSigner$__serpro as $u_Lpresto_types$DocSigner$__serpro };
var $t_Lpresto_types$DocSigner$__shodo = null;
function $u_Lpresto_types$DocSigner$__shodo(x) {
  $t_Lpresto_types$DocSigner$__shodo = x;
}
export { $t_Lpresto_types$DocSigner$__shodo as $t_Lpresto_types$DocSigner$__shodo, $u_Lpresto_types$DocSigner$__shodo as $u_Lpresto_types$DocSigner$__shodo };
//# sourceMappingURL=presto.types$-Doc-Signer$.js.map
